import { NavLink } from "react-router-dom";
import { Menu, type LucideIcon } from "lucide-react";

export interface MobileTab {
  to: string;
  label: string;
  icon: LucideIcon;
  end?: boolean;
}

/**
 * Bottom navigation bar for mobile (hidden on md+). The leftmost button opens
 * the full sidebar drawer; the rest are quick links to the primary sections.
 */
export default function MobileTabBar({ items, onMenu }: { items: MobileTab[]; onMenu: () => void }) {
  return (
    <nav
      className="nav-marble fixed inset-x-0 bottom-0 z-40 flex items-stretch border-t border-white/50 md:hidden"
      style={{ paddingBottom: "max(0px, env(safe-area-inset-bottom))" }}
    >
      <button
        onClick={onMenu}
        className="flex flex-1 flex-col items-center justify-center gap-0.5 py-2 text-ink-500 active:bg-white/45"
        aria-label="Open menu"
      >
        <Menu size={20} />
        <span className="text-[10px] font-medium">Menu</span>
      </button>
      {items.map(({ to, label, icon: Icon, end }) => (
        <NavLink
          key={to}
          to={to}
          end={end}
          className={({ isActive }) =>
            `flex flex-1 flex-col items-center justify-center gap-0.5 py-2 active:bg-white/45 ${
              isActive ? "text-[var(--accent-strong)]" : "text-ink-500"
            }`
          }
        >
          <Icon size={20} />
          <span className="max-w-full truncate px-0.5 text-[10px] font-medium">{label}</span>
        </NavLink>
      ))}
    </nav>
  );
}
